import {
  Paragraph, TextRun, Table, TableRow, TableCell,
  WidthType, BorderStyle, ShadingType, AlignmentType,
} from 'docx';

const NONE = { style: BorderStyle.NONE, size: 0, color: 'FFFFFF' };
const NO_BORDERS = { top: NONE, bottom: NONE, left: NONE, right: NONE };
const TABLE_NO_BORDERS = { ...NO_BORDERS, insideH: NONE, insideV: NONE };
const THIN_H = { style: BorderStyle.SINGLE, size: 2, color: 'bbbbbb' };

const GREEN = '04aa00';
const WHITE = 'FFFFFF';

function renderCellValue(v) {
  if (v === 0 || v === '0' || v === null || v === undefined || v === '') return '';
  return String(v);
}

export function renderTutkimustarpeetTauluBlockDocx({ ptsContext, children }) {
  if (!ptsContext) return;

  const currentYear = new Date().getFullYear();
  const tableData = ptsContext.tutkimusData || [];
  const totals = ptsContext.tutkimusYhteensa || [];
  const years = ptsContext.years || Array.from({ length: 11 }, (_, i) => currentYear + i);

  const totalCols = 1 + years.length;
  const tableRows = [];

  // ── Super-header ─────────────────────────────────────────────────────────────
  tableRows.push(new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({
          children: [new TextRun({
            text: `Kustannusarvio (x 1000€) Kustannustaso ${currentYear} sis. Alv 25,5%`,
            bold: true, color: WHITE, size: 14,
          })],
          alignment: AlignmentType.RIGHT,
        })],
        columnSpan: totalCols,
        shading: { fill: GREEN, type: ShadingType.SOLID },
        borders: NO_BORDERS,
      }),
    ],
  }));

  // ── Column headers ────────────────────────────────────────────────────────────
  tableRows.push(new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({ children: [new TextRun({ text: 'Tutkimustarpeet', bold: true, color: WHITE, size: 16 })] })],
        shading: { fill: GREEN, type: ShadingType.SOLID },
        borders: NO_BORDERS,
        width: { size: 35, type: WidthType.PERCENTAGE },
      }),
      ...years.map(y => new TableCell({
        children: [new Paragraph({
          children: [new TextRun({ text: String(y), bold: true, color: WHITE, size: 14 })],
          alignment: AlignmentType.CENTER,
        })],
        shading: { fill: GREEN, type: ShadingType.SOLID },
        borders: NO_BORDERS,
      })),
    ],
  }));

  // ── Body rows ─────────────────────────────────────────────────────────────────
  tableData.forEach(section => {
    section.items.forEach(item => {
      const label = (item.label || '').trim();
      if (label.length < 2) return;
      tableRows.push(new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ children: [new TextRun({ text: label, size: 16 })], spacing: { after: 40 } })],
            borders: { top: NONE, bottom: THIN_H, left: NONE, right: NONE },
          }),
          ...(item.values || []).map(v => new TableCell({
            children: [new Paragraph({
              children: [new TextRun({ text: renderCellValue(v), size: 16 })],
              alignment: AlignmentType.CENTER,
              spacing: { after: 40 },
            })],
            borders: { top: NONE, bottom: THIN_H, left: NONE, right: NONE },
          })),
        ],
      }));
    });
  });

  // ── Totals row ────────────────────────────────────────────────────────────────
  tableRows.push(new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({ children: [new TextRun({ text: 'YHTEENSÄ', bold: true, color: WHITE, size: 16 })] })],
        shading: { fill: GREEN, type: ShadingType.SOLID },
        borders: NO_BORDERS,
      }),
      ...totals.map(sum => new TableCell({
        children: [new Paragraph({
          children: [new TextRun({ text: sum === 0 ? '' : String(sum), bold: true, color: WHITE, size: 16 })],
          alignment: AlignmentType.CENTER,
        })],
        shading: { fill: GREEN, type: ShadingType.SOLID },
        borders: NO_BORDERS,
      })),
    ],
  }));

  children.push(
    new Table({
      rows: tableRows,
      width: { size: 100, type: WidthType.PERCENTAGE },
      borders: TABLE_NO_BORDERS,
    })
  );
  children.push(new Paragraph({ children: [new TextRun('')], spacing: { after: 160 } }));
}
